import React from "react";
import "./DescriptionBox.css";

export const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">descriptionBox</div>
        <div className="descriptionbox-nav-box fade">Reviews(122)</div>
      </div>
      <div className="descriptionbox-description">
        <p>
          {" "}
          Ae e-commerce website is an online platform that facilitates buying
          and selling of products or services over the internet and serves as a
          virtual marketplace where businesss and individual showcase their
          products, interact with customers, and conduct transactions without
          the need for physical presence
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum ab
          suscipit minima maiores neque facilis soluta optio, nobis impedit,
          architecto rerum assumenda sed accusamus quibusdam commodi fugiat at
          reiciendis alias?
        </p>
      </div>
    </div>
  );
};
